export const GET_FRUITSIZE = "GET_FRUITSIZE";
export const GET_FRUITSIZE_UPDATE = "GET_FRUITSIZE_UPDATE";
export const COPY_FRUITSIZE = "COPY_FRUITSIZE";